import { useEffect } from "react";

export const SetDocumentTitle = ({ title }: { title: string }) => {
    useEffect(() => {
        document.title = title;
    }, [title]);

    return null;
};
